import { FC, PropsWithChildren, Suspense } from 'react';
import { useRoutes } from 'react-router-dom';
import { Routes } from './routes';
import { CircularProgress } from '@mui/material';
import { FlexDiv } from 'crono-fe-common/components/Layout/FlexDiv';

const AppRoutes: FC<PropsWithChildren> = () => {
  const routes = useRoutes(Routes);

  return (
    <Suspense
      fallback={
        <FlexDiv
          height="100%"
          width="100%"
          alignItems="center"
          justifyContent="center"
        >
          <CircularProgress />
        </FlexDiv>
      }
    >
      {routes}
    </Suspense>
  );
};

export default AppRoutes;
